import { Helmet } from "react-helmet";
import hero from "../images/salesTeamHero.jpg";
import ellen from "../images/ellen.jpg";
import shintaro from "../images/shintaro.jpg";
import SalesCard from "../components/SalesCard";
import maui from "../images/2 Maui.jpg";

function SalesPackets() {
  return (
    <>
      <Helmet>
        <title>Atlantis Submarine Adventures | Sales Packets</title>
      </Helmet>
      <div className="container mw-100">
        <div className="row">
          <img src={hero} className="p-0 aboutHero" alt="hero" />
        </div>
        <div
          className="row pt-5 bg-white text-center justify-content-center"
          style={{ color: "#03286B" }}
        >
          <p className="fs-2 fw-bold">ATLANTIS SALES TEAM</p>
          <SalesCard
            pic={ellen}
            title={
              <>
                Atlantis Submarines{" "}
                <span className="text-nowrap">Waikiki &</span>
                <br />
                Majestic by Atlantis Cruises
              </>
            }
            name="ELLEN DAYUHA"
            position="Director of Oahu Sales"
            phone="808-548-9094"
            email="edayuha"
            button="OAHU"
            link="https://drive.google.com/folderview?id=0B59kuuu0LZ90cHVya0pqSkQzaDA&resourcekey=0-8Dly3JKHsA4MY6038DMEeg"
          />
          <hr className="salesHR m-auto" />
          <SalesCard
            pic={maui}
            title="Atlantis Submarines Maui"
            name="REGINA VAN BUREN"
            position="Maui Sales Manager"
            phone="808-268-9905"
            email="rvanburen"
            button="MAUI"
            link="https://drive.google.com/drive/folders/0B59kuuu0LZ90VkJFLW5XRUtfTFE?resourcekey=0-gFo2SpPALDiOyojmP7vBPg"
            // linkName="2026_Maui_Sub.pdf"
          />
          <hr className="salesHR m-auto" />
          <SalesCard
            pic={shintaro}
            title="Atlantis Submarines Kona"
            name="SHINTARO HIRANO"
            position="Kona Sales Manager"
            phone="808-329-3175 ext 0133"
            email="shirano"
            button="KONA"
            link="https://drive.google.com/folderview?id=0B59kuuu0LZ90bmU4ZVlVa3Vzcm8&resourcekey=0-jyIO5DeYVaVpHcXtXmVL7A"
          />
        </div>
      </div>
    </>
  );
}

export default SalesPackets;
